import React, { useCallback, useEffect, useState } from 'react'
import { AppBar, Box } from '@mui/material'
import { useSelector } from 'react-redux'
import { getCemFeatures, getUserInfo } from 'src/store/userInfo/userInfoSlice'
import { isFeatureFlagEnabled } from 'src/rsmCoreComponents/utils/featureFlagUtils'
import { useDeviceType } from '../../../rsmCoreComponents/hooks/useDeviceType'
import { Styles } from '../../../types'
import CombinedMenus from '../CombinedMenus'
import HideOnScroll from '../HideOnScroll'

const styles: Styles = {
  appBar: (theme) => ({
    backgroundColor: theme.palette.common.white,
    zIndex: 1300,
  }),
}

type MainMenuProps = {
  currentItem?: string
  subNavSlot?: React.ReactNode
}

const MainMenu = ({ currentItem = '', subNavSlot = null }: MainMenuProps) => {
  const { isMobile, isTablet, isDesktop } = useDeviceType()
  const [maxHeight, setMaxHeight] = useState('auto')
  const userInfo = useSelector(getUserInfo)
  const cemFeatures = useSelector(getCemFeatures)
  const isUIRedesignEnabled = isFeatureFlagEnabled(
    'UI_Redesign',
    userInfo.emailAddress,
    cemFeatures,
  )
  const menuStyle =
    isDesktop && isUIRedesignEnabled && currentItem === 'home'
      ? {
          height: maxHeight,
          transition: 'height 400ms ease-out',
        }
      : undefined

  const computedStyles = {
    spacer: useCallback(
      () => ({
        height: subNavSlot ? '11rem' : '7.9375rem',
      }),
      [subNavSlot],
    ),
  }

  useEffect(() => {
    const handleScroll = () => {
      if (isDesktop && isUIRedesignEnabled && currentItem === 'home') {
        setMaxHeight(window.scrollY === 0 ? '16rem' : '0rem')
      }
    }

    window.addEventListener('scroll', handleScroll)

    return () => {
      window.removeEventListener('scroll', handleScroll)
    }
  }, [])

  useEffect(() => {
    if (isDesktop && isUIRedesignEnabled && currentItem === 'home') {
      setMaxHeight('16rem')
    }
  }, [currentItem])

  return (
    <header style={menuStyle}>
      <Box sx={computedStyles.spacer} />

      {/* We can't put AppBar into CombinedMenus :(  */}
      {isMobile || isTablet ? (
        <HideOnScroll>
          <AppBar sx={styles.appBar}>
            <CombinedMenus
              currentItem={currentItem}
              bottomBorder={subNavSlot == null}
            />
            {subNavSlot}
          </AppBar>
        </HideOnScroll>
      ) : (
        <AppBar sx={styles.appBar}>
          <CombinedMenus currentItem={currentItem} />
        </AppBar>
      )}
    </header>
  )
}

export default MainMenu
